





























































































import { Component, Vue } from 'vue-property-decorator';
import { mdbProgress, mdbBtn, mdbTooltip } from '@folky-tools/mdbvue';
import { VueGoodTable } from '@folky-tools/vue-good-table';
import { usersService, axiosService, authorizationManagerService } from '@/services';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { BusinessContactMessage } from '@/models/contacts/business-contact-message';

@Component({
    components: {
        mdbProgress,
        mdbBtn,
        mdbTooltip,
        VueGoodTable,
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    }
})
export default class BusinessContactsListView extends Vue {
    private rows: BusinessContactMessage[] = [];
    private columns: any[] = [];
    private totalRecords: number = 0;
    private actualUserCanReadMultipleBusinesses: boolean = false;
    private isLoading: boolean = false;
    private ordersPerPage: number = 20;

    private serverParams: any = {
        columnFilters: {},
        sort: [
            {
                field: 'dateTheFormWasSubmitted',
                type: 'desc'
            }
        ],
        page: 1,
        perPage: this.ordersPerPage
    };

    private async beforeMount(): Promise<void> {
        this.actualUserCanReadMultipleBusinesses = authorizationManagerService.isAdmin || authorizationManagerService.canReadMultipleBusinesses;

        await this.setColumns(this.actualUserCanReadMultipleBusinesses);
        await this.loadItems();
    }

    private async mounted(): Promise<void> {
        if (this.$route.query.businessName) {
            this.$root.$emit('change-active-page', 'views.contacts.businessContactsListView.titleSingleBusiness', this.$route.query.businessName.toString());
        } else {
            this.$root.$emit('change-active-page', 'views.contacts.businessContactsListView.title');
        }

        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.BusinessContacts,
                scope: UserActionScopeType.List
            })
        );
    }

    private async loadItems(): Promise<void> {
        this.isLoading = true;

        const response: any = await axiosService.instance.get('businesses/organization/completed-forms/query', {
            params: this.getQueryParams(this.serverParams.sort, this.serverParams.page, this.serverParams.perPage)
        });

        this.rows = [];

        this.totalRecords = response.data.count;
        response.data.items.forEach((item: any) => {
            this.rows.push(new BusinessContactMessage(item));
        });

        this.isLoading = false;
    }

    private getQueryParams(sortOrder: any, currentPage: number, perPage: number): any {
        return {
            $skip: (currentPage - 1) * perPage,
            $top: perPage,
            $orderby: this.getQueryOrderFromColumn(sortOrder),
            $filter: this.getQueryFilterFromColumns()
        };
    }

    private getQueryFilterFromColumns(): string | null {
        let queryFilter = '';
        const logicalOperatorBetweenFilters = ' and ';

        for (const key of Object.keys(this.serverParams.columnFilters)) {
            if (this.serverParams.columnFilters[key]) {
                if (key === 'bussinesTheFormWasSubmittedFrom') {
                    queryFilter += `${logicalOperatorBetweenFilters}contains(bussinesTheFormWasSubmittedFrom, '${this.serverParams.columnFilters[key].replace('\'', '\'\'')}')`;
                }

                if (key === 'emailCompletedInTheForm') {
                    queryFilter += `${logicalOperatorBetweenFilters}contains(emailCompletedInTheForm, '${this.serverParams.columnFilters[key]}')`;
                }
            }
        }

        return queryFilter === '' ? null : queryFilter.substring(logicalOperatorBetweenFilters.length);
    }

    private getQueryOrderFromColumn(sortOrder: any): string | null {
        if (sortOrder && sortOrder.length === 1) {
            if (sortOrder[0].field === 'dateTheFormWasSubmitted') {
                return `dateTheFormWasSubmitted ${sortOrder[0].type}`;
            } else {
                return `${sortOrder[0].field} ${sortOrder[0].type}`;
            }
        } else {
            return null;
        }
    }

    private setColumns(showBusinessTradeNameColumn: boolean): void {
        this.columns = [
            { field: 'id', type: 'text', sortable: false },
            { field: 'consumerNameTheFormWasSubmittedFrom', type: 'text', sortable: false },
            {
                field: 'dateTheFormWasSubmitted',
                sortable: true,
                type: 'text'
            }
        ];

        if (showBusinessTradeNameColumn) {
            this.columns.push({
                field: 'bussinesTheFormWasSubmittedFrom',
                sortable: false,
                type: 'text',
                filterOptions: {
                    enabled: true,
                    placeholder: this.$t('common.placeholders.searchBySeller'),
                    filterValue: ''
                }
            });
        }

        this.columns.push(
            { field: 'fullNameCompletedInTheForm', sortable: false, type: 'text' },
            {
                field: 'emailCompletedInTheForm',
                sortable: false,
                type: 'text',
                filterOptions: {
                    enabled: true,
                    placeholder: this.$t('common.placeholders.searchByEmail'),
                    filterValue: ''
                }
            },
            { field: 'phoneCompletedInTheForm', sortable: false, type: 'text' },
            { field: 'messageCompletedInTheForm', sortable: false, type: 'text' }
        );
    }

    private async onPageChange(params: any): Promise<void> {
        this.updateParams({ page: params.currentPage });
        await this.loadItems();
    }

    private async onSortChange(params: any): Promise<void> {
        this.updateParams({
            sort: [
                {
                    type: params[0].type,
                    field: params[0].field
                }
            ]
        });
        await this.loadItems();
    }

    private async onColumnFilter(params: any): Promise<void> {
        this.serverParams.page = 1;
        this.updateParams(params);
        await this.loadItems();
    }

    private async onPerPageChange(params: any): Promise<void> {
        this.updateParams({ perPage: params.currentPerPage });
        await this.loadItems();
    }

    private updateParams(newProps: any): void {
        this.serverParams = { ...this.serverParams, ...newProps };
    }
}
